import { Controller } from "@hotwired/stimulus";
import queryString from 'query-string'

import debounce from "../../../javascript/utils/debounce";

export default class extends Controller {
  static values = {
    paramKey: String,
  }

  connect(){
    this.onChange = debounce(this.onChange.bind(this), 300)
  }

  onChange(e){
    this.submit(e.target.value)
  }

  submit(value) {
    const form = this.element

    const currentParams = queryString.parse(location.search)
    const mergedParams = {
      ...currentParams,
      [this.paramKeyValue]: value,
    }

    const stringifiedParams = queryString.stringify(mergedParams)
    
    const newUrl = `${form.action}?${stringifiedParams}`

    Turbo.visit(newUrl, { frame: "search-results", action: "replace" })
  }
}
